import { pushSignUpEvent } from './gtm';
import { reportGoogleAdsConversion } from './google-ads';
import { reportLinkedInConversion } from './linkedin';

/**
 * Handles sign-up button click events by firing all tracking events.
 * This is a convenience function that fires GTM, Google Ads, and LinkedIn tracking events.
 *
 * @returns void
 */
export function handleSignUpClick(): void {
  pushSignUpEvent();
  reportGoogleAdsConversion();
  reportLinkedInConversion();
}
